/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Range_BucketsInputs */

const en_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Range Ball Bucket Prices`)
};

const es_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios de cubetas de pelotas`)
};

const de_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise für Range-Ball-Eimer`)
};

const zh_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习场球桶价格`)
};

const ar_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أسعار سلال كرات الميدان`)
};

const fr_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix des seaux de balles`)
};

const vi_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá xô bóng sân tập`)
};

const sw_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei za ndoo za mipira ya uwanja wa mazoezi`)
};

const th_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคาถังลูกกอล์ฟสนามไดร์ฟ`)
};

const bs_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cijene kanti loptica`)
};

const ja_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レンジボールバケット料金`)
};

const ko_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레인지 볼 버킷 가격`)
};

const pt_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços dos baldes de bolas`)
};

const it_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi dei cestini di palline`)
};

const sv_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser på bollhinkar`)
};

const nl_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijzen ballenemmers`)
};

const da_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser på boldkurve`)
};

const nb_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser på ballkurver`)
};

const fi_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pallokorien hinnat`)
};

const pl_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny koszyków piłek`)
};

const ru_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены на корзины мячей`)
};

const tr_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Kovası Fiyatları`)
};

const hi_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रेंज बॉल बाल्टी मूल्य`)
};

const id_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga Ember Bola`)
};

const ms_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga Baldi Bola Latihan`)
};

const cs_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny košíků míčků`)
};

const el_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τιμές κουβά με μπάλες`)
};

const he_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחירי דליי כדורים`)
};

const af_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pryse vir balemmers`)
};

const hu_prices_range_buckets = /** @type {(inputs: Prices_Range_BucketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labdakosár-árak`)
};

/**
* | output |
* | --- |
* | "Range Ball Bucket Prices" |
*
* @param {Prices_Range_BucketsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_range_buckets = /** @type {((inputs?: Prices_Range_BucketsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Range_BucketsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_range_buckets(inputs)
	if (locale === "de") return de_prices_range_buckets(inputs)
	if (locale === "zh") return zh_prices_range_buckets(inputs)
	if (locale === "ar") return ar_prices_range_buckets(inputs)
	if (locale === "fr") return fr_prices_range_buckets(inputs)
	if (locale === "vi") return vi_prices_range_buckets(inputs)
	if (locale === "sw") return sw_prices_range_buckets(inputs)
	if (locale === "th") return th_prices_range_buckets(inputs)
	if (locale === "bs") return bs_prices_range_buckets(inputs)
	if (locale === "ja") return ja_prices_range_buckets(inputs)
	if (locale === "ko") return ko_prices_range_buckets(inputs)
	if (locale === "pt") return pt_prices_range_buckets(inputs)
	if (locale === "it") return it_prices_range_buckets(inputs)
	if (locale === "sv") return sv_prices_range_buckets(inputs)
	if (locale === "nl") return nl_prices_range_buckets(inputs)
	if (locale === "da") return da_prices_range_buckets(inputs)
	if (locale === "nb") return nb_prices_range_buckets(inputs)
	if (locale === "fi") return fi_prices_range_buckets(inputs)
	if (locale === "pl") return pl_prices_range_buckets(inputs)
	if (locale === "ru") return ru_prices_range_buckets(inputs)
	if (locale === "tr") return tr_prices_range_buckets(inputs)
	if (locale === "hi") return hi_prices_range_buckets(inputs)
	if (locale === "id") return id_prices_range_buckets(inputs)
	if (locale === "ms") return ms_prices_range_buckets(inputs)
	if (locale === "cs") return cs_prices_range_buckets(inputs)
	if (locale === "el") return el_prices_range_buckets(inputs)
	if (locale === "he") return he_prices_range_buckets(inputs)
	if (locale === "af") return af_prices_range_buckets(inputs)
	if (locale === "hu") return hu_prices_range_buckets(inputs)
	return en_prices_range_buckets(inputs)
});